import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


// Registramos el service worker y definimos el callback onUpdate
serviceWorkerRegistration.register({
    onUpdate: registration => {
      // Aquí podemos manejar la actualización: mostrar un banner o notificar de alguna forma
      console.log('Nueva actualización disponible:', registration);
      // Puedes, por ejemplo, guardar el registration en un estado global o notificar a un componente React
    }
  });